export default __webpack_public_path__ + "static/media/remoto-zoom-canvas.24e04f46.svg";